import * as React from "react";

const Clear = () => {
  return <div className="clear" />;
};

export default Clear;



// WEBPACK FOOTER //
// ./src/theme/Clear.js